import React, {FC} from 'react';

import {center} from '../../../../libs/shared/ui/src/styles/mixins';
import {styled} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {EmojiDefinitionAndSkinTone} from '../../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {Emoji} from '../emoji/emoji';

/*
 * Props.
 */

export interface NavigationLineEmojiProps {
  /** The emoji to display */
  emojiAndSkinTone: EmojiDefinitionAndSkinTone;
}

/*
 * Style.
 */

const StyledEmojiDiv = styled.div`
  grid-area: icon;
  ${center()};
`;

/*
 * Component.
 */

export const NavigationLineEmoji: FC<NavigationLineEmojiProps> = ({emojiAndSkinTone}) => (
  <StyledEmojiDiv>
    <Emoji {...emojiAndSkinTone} size={16} />
  </StyledEmojiDiv>
);
